import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalContext';

const NavMenu = () => {
  const { t } = useTranslation();
  const { navMenuItems } = useGlobalContext();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      const offset = 80; // Navbar height offset
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleClick = (e, route) => {
    // Don't prevent default for actual route navigation (like /documentation)
    if (!route.startsWith('#') && route !== '/') {
      return;
    }
    
    e.preventDefault();
    
    // If clicking Home
    if (route === '/') {
      if (location.pathname !== '/') {
        // If not on home page, navigate to home
        navigate('/');
        // Scroll to top after navigation
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      } else {
        // Already on home page, just scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } 
    // If clicking hash links (Pricing, Contact)
    else if (route.startsWith('#')) {
      const elementId = route.substring(1);
      
      if (location.pathname !== '/') {
        // If not on home page, navigate to home first
        navigate('/');
        // Then scroll to element after navigation
        setTimeout(() => {
          scrollToElement(elementId);
        }, 100);
      } else {
        // Already on home page, just scroll to element
        scrollToElement(elementId);
      }
    }
  };

  const getTranslationKey = (label) => {
    if (label === 'Home') return 'home';
    if (label === 'Pricing Plans') return 'pricing';
    if (label === 'Contact Us') return 'contact';
    if (label === 'Documentation') return 'documentation';
    return 'home';
  };

  return (
    <nav className="nav-menu">
      {navMenuItems.map((item) => {
        // Use Link for actual routes, <a> for hash links
        if (item.route.startsWith('#') || item.route === '/') {
          return (
            <a 
              key={item.id} 
              href={item.route} 
              className="nav-link"
              onClick={(e) => handleClick(e, item.route)}
            >
              {t(`nav.${getTranslationKey(item.label)}`)}
            </a>
          );
        }
        
        return (
          <Link 
            key={item.id} 
            to={item.route} 
            className="nav-link"
          >
            {t(`nav.${getTranslationKey(item.label)}`)}
          </Link>
        );
      })}
    </nav>
  );
};

export default NavMenu;

